import { PREFIX } from './base';

export const WaterfallDefaultSeriesField = `${PREFIX}_waterfall_default_seriesField`;
